import * as React from "react";
import { IconProps } from "../types";

const Sitemap3OutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M13.25,11.75v-1c0-1.105-.895-2-2-2h-2.25s-2.25,0-2.25,0c-1.105,0-2,.895-2,2v1" />
          <line x1="9" y1="6.25" x2="9" y2="8.75" />
          <circle cx="4.75" cy="14" r="2.25" />
          <circle cx="9" cy="4" r="2.25" />
          <circle cx="13.25" cy="14" r="2.25" />
        </g>
      </svg>
    );
  },
);

export default Sitemap3OutlineIcon;
